// ** React Imports
import { createContext, useState, ReactNode } from 'react'

import ItaptecSpinner from "../layouts/components/ItaptecSpinner";
import {LoaderValuesType} from "./types";

// ** Defaults
const defaultProvider: LoaderValuesType = {
  showLoader: () => null,
  hideLoader: () => null,
}

const LoaderContext = createContext(defaultProvider)

type Props = {
  children: ReactNode
}

const LoaderProvider = ({ children }: Props) => {
  // ** States
  const [loading, setLoading] = useState<boolean>(false);

  const showLoader = () => setLoading(true);
  
  const hideLoader = () => setLoading(false);

  const values = {
    showLoader: showLoader,
    hideLoader: hideLoader
  }

  return (
      <LoaderContext.Provider value={values}>
        {
          loading && <ItaptecSpinner />
        }

        {children}
      </LoaderContext.Provider>
  )
}

export { LoaderContext, LoaderProvider }
